import StarIcon from "./star";
import StarActiveIcon from "./star-active";
import LikeIcon from "./like";
import LikeActiveIcon from "./like-active";
import ClockIcon from "./clock";
import UserIcon from "./user";
import CheckIcon from "./check";
import ArrowLeftIcon from "./arrow-left";
import ArrowRightIcon from "./arrow-right";
import PlusIcon from "./plus";
import DoneIcon from "./done";
import IngredientDelete from "./ingredient-delete";
import SavedMenu from "./saved-menu";
import SubscriptionsMenu from "./subscriptions-menu";
import LogoutMenu from "./logout-menu";
import ResetPasswordMenu from "./reset-password-menu";
import Cart from "./cart";
import AddUser from "./add-user";
import ReceiptDelete from "./receipt-delete";
import ArrowExpand from "./arrow-expand";
import PaginationArrow from "./pagination-arrow";
import PopupClose from "./popup-close";
import AddAvatarIcon from "./add-avatar";
import DeleteAvatarIcon from "./delete-avatar";
import CopyLinkIcon from "./copy-link";

export default {
  StarIcon,
  ReceiptDelete,
  PopupClose,
  Cart,
  StarActiveIcon,
  AddUser,
  ClockIcon,
  UserIcon,
  PaginationArrow,
  CheckIcon,
  ArrowLeftIcon,
  IngredientDelete,
  ArrowRightIcon,
  PlusIcon,
  DoneIcon,
  LikeIcon,
  LikeActiveIcon,
  ArrowExpand,
  SavedMenu,
  SubscriptionsMenu,
  LogoutMenu,
  ResetPasswordMenu,
  AddAvatarIcon,
  DeleteAvatarIcon,
  CopyLinkIcon,
};
